    document.addEventListener('DOMContentLoaded', function () {
      function copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(() => {
          const element = document.querySelector(`[data-copy="${text}"]`);
          if (element) {
            element.classList.add('flashBG');
            setTimeout(() => element.classList.remove('flashBG'), 1000);
          }
        });
      }

      document.querySelectorAll('.coupon_code_pdp').forEach((icon) => {
        icon.addEventListener('click', function () {
          const code = this.previousElementSibling?.textContent;
          if (code) {
            copyToClipboard(code);
          }
        });
      });
    });

    // Add the show-more custom element before line 1682
    class ShowMore extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick(event) {
        event.preventDefault();

        // Find the details accordion element
        const detailsAccordion = document.getElementById('details-accordion');

        if (detailsAccordion) {
          // Add the open attribute to expand the accordion
          detailsAccordion.setAttribute('open', '');

          // Scroll to the element with smooth behavior
          detailsAccordion.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }
    }

    // Register the custom element
    if (!customElements.get('show-more')) {
      customElements.define('show-more', ShowMore);
    }

    class ProductSwatch extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.handleSwatchClick.bind(this));
      }

      // Handle swatch click event
      async handleSwatchClick(event) {
        if (event.target.closest('button, input, label, a[href^="#"]')) return;
        if (this.classList.contains('is-current')) return;

        event.preventDefault();

        // Get the product URL and handle from the data attributes
        const productUrl = this.dataset.productUrl;
        const productHandle = this.dataset.productHandle;

        if (!productUrl || !productHandle) return;

        // Show loading state
        this.setLoadingState(true);

        try {
          // Fetch the entire product page instead of just the section
          const response = await fetch(productUrl);
          const html = await response.text();

          // Parse the HTML content
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Find the product section to update
          const productSection = document.getElementById(this.getAttribute('data-section-id'));

          if (productSection) {
            // Get the corresponding section from the fetched HTML
            const newProductSection = doc.getElementById(this.getAttribute('data-section-id'));

            if (newProductSection) {
              // Replace the entire section content
              productSection.innerHTML = newProductSection.innerHTML;

              // Handle scripts more carefully to avoid redeclaration errors
              const scriptElements = productSection.querySelectorAll('script');
              scriptElements.forEach((oldScript) => {
                // Skip scripts that might cause redeclaration errors
                if (
                  oldScript.textContent.includes('class') ||
                  oldScript.textContent.includes('function') ||
                  oldScript.textContent.includes('const ') ||
                  oldScript.textContent.includes('let ') ||
                  oldScript.textContent.includes('var ')
                ) {
                  // For scripts that define classes/functions, we'll evaluate them in a safer way
                  try {
                    // Create a new function from the script content and execute it
                    // This avoids redeclaration errors in the global scope
                    const scriptContent = oldScript.textContent;
                    const scriptFunc = new Function(scriptContent);
                    scriptFunc();
                  } catch (scriptError) {
                    console.warn('Script execution error:', scriptError);
                  }
                } else {
                  // For other scripts (like inline event handlers), replace them normally
                  const newScript = document.createElement('script');
                  Array.from(oldScript.attributes).forEach((attr) => {
                    newScript.setAttribute(attr.name, attr.value);
                  });
                  newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                  oldScript.parentNode.replaceChild(newScript, oldScript);
                }
              });

              // Dispatch events to notify other components
              document.dispatchEvent(
                new CustomEvent('shopify:section:load', {
                  detail: { section: productSection },
                })
              );

              document.dispatchEvent(
                new CustomEvent('product:loaded', {
                  bubbles: true,
                  detail: { productElement: productSection },
                })
              );
            }
          }

          // Update the URL in the browser without reloading the page
          history.replaceState(null, '', productUrl);
        } catch (error) {
          console.error('Error fetching product:', error);
        } finally {
          // Hide loading state
          this.setLoadingState(false);
          this.scrollToTop();
        }
      }

      scrollToTop() {
        window.scrollTo({
          top: 150,
          behavior: 'smooth',
        });
      }

      // Set loading state on the swatch block
      setLoadingState(isLoading) {
        const host =
          this.closest('[data-product-swatch-loading]') ||
          this.closest('custom-carousel');
        if (host) {
          host.classList.toggle('loading', isLoading);
        }
      }
    }

    // Define the custom element
    if (!customElements.get('product-swatch')) {
      customElements.define('product-swatch', ProductSwatch);
    }

    document.addEventListener('DOMContentLoaded', function () {
      class ProductAddonCart extends HTMLElement {
        constructor() {
          super();
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.productHandle = this.dataset.productHandle;
          this.addEventListener('click', this.handleClick.bind(this));
          this.selectedVariantId = this.dataset.productSelectedVariant;

          // Store variant maps for addon products
          this.variantMaps = {};

          // Initialize variant maps
          this.initializeVariantMaps();

          // Set default values for selects if not already set
          this.setDefaultValues();

          this.setupEventListeners();
        }

        // Get and store variant information for all addons
        initializeVariantMaps() {
          // For pre-drape
          const preDrapeSection = this.querySelector('.pre-drape-section');
          if (preDrapeSection) {
            const variantMap = {};
            const dataAttr = preDrapeSection.getAttribute('data-variants');

            if (dataAttr) {
              try {
                // Clean and parse JSON data from the data-variants attribute
                const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
                const variantsData = JSON.parse(cleanedDataAttr);
                console.log('Pre-drape variants data:', variantsData);
                variantsData.forEach((variant) => {
                  variantMap[variant.title] = variant.id;
                  console.log(`Mapping pre-drape: ${variant.title} -> ${variant.id}`);
                });
              } catch (e) {
                console.error('Error parsing pre-drape variants', e);
                console.error('Raw data attribute:', dataAttr);
              }
            }

            // Store the map
            this.variantMaps['pre-drape'] = variantMap;
          }

          // For blouse customization
          const blouseCustomizationSection = this.querySelector('.blouse-customization-section');
          if (blouseCustomizationSection) {
            const variantMap = {};
            const dataAttr = blouseCustomizationSection.getAttribute('data-variants');

            console.log('Blouse customization data-variants:', dataAttr);

            if (dataAttr) {
              try {
                // Clean and parse JSON data from the data-variants attribute
                const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
                const variantsData = JSON.parse(cleanedDataAttr);
                console.log('Parsed blouse customization variants:', variantsData);
                variantsData.forEach((variant) => {
                  variantMap[variant.title] = variant.id;
                  console.log(`Mapping blouse customization: ${variant.title} -> ${variant.id}`);
                });
              } catch (e) {
                console.error('Error parsing blouse customization variants', e);
                console.error('Raw data attribute:', dataAttr);
              }
            }

            console.log('Blouse customization variant map:', variantMap);
            // Store the map
            this.variantMaps['blouse-customization'] = variantMap;
          }

          // For all addon options
          this.querySelectorAll('.addon-option').forEach((addonOption, index) => {
            const variantMap = {};
            const dataAttr = addonOption.getAttribute('data-variants');

            if (dataAttr) {
              try {
                // Clean and parse JSON data from the data-variants attribute
                const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
                const variantsData = JSON.parse(cleanedDataAttr);
                variantsData.forEach((variant) => {
                  variantMap[variant.title] = variant.id;
                });
              } catch (e) {
                console.error(`Error parsing addon variants for index ${index}`, e);
                console.error('Raw data attribute:', dataAttr);
              }
            }

            // Store the map
            this.variantMaps[`addon-${index}`] = variantMap;
          });
        }

        setDefaultValues() {
          // Don't set default values for dropdown selects
          // Just make sure they start with the empty option
          this.querySelectorAll('select').forEach((select) => {
            // Always reset to first option (usually "Choose a size")
            select.selectedIndex = 0;
          });
          this.querySelectorAll('input.pre-drape-size[type="radio"]').forEach((radio) => {
            radio.checked = false;
          });
        }

        setupEventListeners() {
          // Addon dropdown triggers (pre-drape, blouse-customization - pair-with style)
          this.querySelectorAll('.addon-dropdown-section').forEach((section) => {
            const trigger = section.querySelector('.addon-dropdown__trigger');
            const panel = section.querySelector('.addon-dropdown__panel');
            const checkbox = section.querySelector('.pre-drape-checkbox, .blouse-customization-checkbox');
            const blouseSelect = section.querySelector('.blouse-customization-size');
            const preDrapeRadios = section.querySelectorAll('input.pre-drape-size[type="radio"]');
            const chevron = trigger?.querySelector('.addon-dropdown__chevron');
            const icon = chevron || trigger?.querySelector('svg');

            if (!trigger || !panel) return;

            trigger.addEventListener('click', () => {
              const isNowHidden = panel.classList.toggle('hidden');
              trigger.setAttribute('aria-expanded', !isNowHidden);
              if (icon) icon.style.transform = isNowHidden ? 'rotate(180deg)' : '';
            });

            const syncFromSize = () => {
              const preDrapeChecked = section.querySelector('input.pre-drape-size:checked');
              const hasPreDrape = !!(preDrapeChecked && preDrapeChecked.value);
              const hasBlouse = !!(blouseSelect && blouseSelect.value);
              const hasSelection = hasPreDrape || hasBlouse;
              if (checkbox) {
                checkbox.checked = hasSelection;
                trigger.classList.toggle('addon-dropdown__trigger--selected', hasSelection);
                this.toggleAddToCartButton();
              }
            };

            if (blouseSelect && checkbox) {
              blouseSelect.addEventListener('change', syncFromSize);
            }
            if (preDrapeRadios.length && checkbox) {
              preDrapeRadios.forEach((radio) => radio.addEventListener('change', syncFromSize));
            }
            const clearPreDrapeBtn = section.querySelector('.pre-drape-clear-text');
            if (clearPreDrapeBtn && checkbox && preDrapeRadios.length) {
              clearPreDrapeBtn.addEventListener('click', () => {
                preDrapeRadios.forEach((radio) => {
                  radio.checked = false;
                });
                syncFromSize();
              });
            }
          });

          // Toggle buttons for main options (addon-options, gifting, gift-wrap, gift-box, bags)
          this.querySelectorAll('.addon-toggle-button').forEach((button) => {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              const targetClass = button.dataset.target;
              const targetContainer = this.querySelector(`.${targetClass}`);
              const toggleIcon = button.querySelector('.toggle-icon');
              const chevron = button.querySelector('.addon-dropdown__chevron');
              const svgFallback = chevron ? null : button.querySelector('svg');

              if (targetContainer) {
                const isHidden = targetContainer.classList.contains('hidden');
                targetContainer.classList.toggle('hidden');
                button.classList.toggle('active');
                button.setAttribute('aria-expanded', !isHidden);
                
                // Chevron SVG points up (^); closed = rotate(180deg) (down), open = no rotate (up)
                if (toggleIcon) {
                  toggleIcon.textContent = isHidden ? '−' : '+';
                } else if (chevron) {
                  chevron.style.transform = isHidden ? '' : 'rotate(180deg)';
                } else if (svgFallback) {
                  svgFallback.style.transform = isHidden ? '' : 'rotate(180deg)';
                }

                // Uncheck all nested checkboxes if collapsing
                if (!isHidden) {
                  targetContainer.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                    checkbox.checked = false;
                  });
                }

                this.toggleAddToCartButton();
              }
            });
          });

          // Individual nested option checkboxes (gift wrap, gift box, bags, matching laces, addons)
          this.querySelectorAll('.gift-wrap-option-checkbox, .gift-box-option-checkbox, .bags-option-checkbox, .matching-laces-option-checkbox, .addon-checkbox').forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
              if (checkbox.classList.contains('addon-checkbox')) {
                this.toggleAddonFields(checkbox);
              }
              this.updateToggleButtonState(checkbox);
              this.toggleAddToCartButton();
            });
          });

          this.querySelectorAll('.gifting-more-toggle, .matching-laces-more-toggle').forEach((moreToggle) => {
            moreToggle.addEventListener('click', () => {
              const isLaces = moreToggle.classList.contains('matching-laces-more-toggle');
              const options = moreToggle.closest(isLaces ? '.matching-laces-options' : '.gifting-options');
              if (!options) return;
              const expandedClass = isLaces ? 'matching-laces-options--expanded' : 'gifting-options--expanded';
              const expanded = options.classList.toggle(expandedClass);
              moreToggle.setAttribute('aria-expanded', expanded);
              moreToggle.setAttribute(
                'aria-label',
                expanded
                  ? (isLaces ? 'Hide extra matching laces' : 'Hide extra gifting options')
                  : (isLaces ? 'Show more matching laces' : 'Show more gifting options')
              );
            });
          });

          // Remove cups fields toggle
          const removeCupsCheckbox = this.querySelector('.remove-cups-checkbox');
          const removeCupsMessageContainer = this.querySelector('.remove-cups-message-container');

          if (removeCupsCheckbox && removeCupsMessageContainer) {
            removeCupsCheckbox.addEventListener('change', () => {
              removeCupsMessageContainer.classList.toggle('hidden', !removeCupsCheckbox.checked);
              this.toggleAddToCartButton();
            });
          }
        }

        toggleAddonFields(checkbox) {
          const addonOption = checkbox.closest('.addon-option');
          const addonFields = addonOption.querySelector('.addon-fields');

          if (addonFields) {
            addonFields.classList.toggle('hidden', !checkbox.checked);
          }
        }

        updateToggleButtonState(checkbox) {
          // Find the parent container (gift-wrap-options, gift-box-options, bags-options, gifting-options, matching-laces-options, or addon-options)
          const optionsContainer = checkbox.closest('.gift-wrap-options, .gift-box-options, .bags-options, .gifting-options, .matching-laces-options, .addon-options');
          
          if (!optionsContainer) return;

          // Find the corresponding toggle button
          const parentSection = optionsContainer.closest('.gift-wrap-container, .gift-box-container, .bags-container, .gifting-container, .matching-laces-container, .addon-selection-container');
          
          if (!parentSection) return;

          const toggleButton = parentSection.querySelector('.addon-toggle-button');
          
          if (!toggleButton) return;

          // Check if any checkbox in this container is checked
          const anyChecked = optionsContainer.querySelector('input[type="checkbox"]:checked');
          
          // Update active class based on selection, but don't auto-hide the container
          if (!anyChecked) {
            toggleButton.classList.remove('active');
          } else {
            // Keep it active if any checkbox is checked
            toggleButton.classList.add('active');
          }
        }

        toggleAddToCartButton() {
          const isAnyCheckboxChecked =
            this.querySelector('.pre-drape-checkbox:checked') ||
            this.querySelector('.blouse-customization-checkbox:checked') ||
            this.querySelector('.addon-checkbox:checked') ||
            this.querySelector('.gift-wrap-option-checkbox:checked') ||
            this.querySelector('.gift-box-option-checkbox:checked') ||
            this.querySelector('.bags-option-checkbox:checked') ||
            this.querySelector('.matching-laces-option-checkbox:checked') ||
            this.querySelector('.remove-cups-checkbox:checked');

          const button = this.querySelector('.addon-submit-button');
          const mainContainer = this;

          // All PDP ATC containers: product-info buy_buttons blocks + sticky bar
          const productInfoATCs = document.querySelectorAll(
            '.product .product-info__block-item[data-block-type="buy-buttons"]'
          );
          const stickyBar = document.querySelector('product-sticky-bar');

          const allATCs = [...productInfoATCs, ...(stickyBar ? [stickyBar] : [])];

          if (button) {
            button.classList.toggle('hidden', !isAnyCheckboxChecked);
            mainContainer.classList.toggle('on-checked-container', isAnyCheckboxChecked);
            allATCs.forEach((atc) => atc?.classList?.toggle('hidden', isAnyCheckboxChecked));
          }
        }

        validateFields() {
          let isValid = true;
          const errors = [];

          const preDrapeCheckbox = this.querySelector('.pre-drape-checkbox');
          if (preDrapeCheckbox?.checked) {
            const preDrapeChecked = this.querySelector('input.pre-drape-size:checked');
            if (!preDrapeChecked?.value) {
              errors.push('Please select a size for pre-drape service');
              isValid = false;
            }
          }

          const blouseCustomizationCheckbox = this.querySelector('.blouse-customization-checkbox');
          if (blouseCustomizationCheckbox?.checked) {
            const sizeSelect = this.querySelector('.blouse-customization-size');
            if (!sizeSelect.value || sizeSelect.value === '') {
              errors.push('Please select a size for blouse customization');
              isValid = false;
            }
          }

          if (!isValid) {
            alert(errors.join('\n'));
          }

          return isValid;
        }


        resetForm() {
          this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
          });

          this.querySelectorAll('input.pre-drape-size[type="radio"]').forEach((radio) => {
            radio.checked = false;
          });

          this.querySelectorAll('select').forEach((select) => {
            if (select.classList.contains('blouse-customization-size')) {
              select.value = '';
            } else if (select.options.length > 0) {
              const selectedOption = select.querySelector('option[selected]');
              if (selectedOption) {
                select.value = selectedOption.value;
              } else {
                select.selectedIndex = 0;
              }
            }
          });

          this.querySelectorAll('input[type="number"], input[type="text"]').forEach((input) => {
            input.value = '';
          });

          this.querySelectorAll('.addon-fields').forEach((fields) => {
            fields.classList.add('hidden');
          });

          const removeCupsMessageContainer = this.querySelector('.remove-cups-message-container');
          if (removeCupsMessageContainer) {
            removeCupsMessageContainer.classList.add('hidden');
          }

          this.querySelectorAll('.addon-dropdown-section .addon-dropdown__trigger').forEach((trigger) => {
            trigger.classList.remove('addon-dropdown__trigger--selected');
          });

          const giftingOptions = this.querySelector('.gifting-options');
          const giftingMoreToggle = this.querySelector('.gifting-more-toggle');
          if (giftingOptions) {
            giftingOptions.classList.remove('gifting-options--expanded');
          }
          if (giftingMoreToggle) {
            giftingMoreToggle.setAttribute('aria-expanded', 'false');
            giftingMoreToggle.setAttribute('aria-label', 'Show more gifting options');
          }

          const matchingLacesOptions = this.querySelector('.matching-laces-options');
          const matchingLacesMoreToggle = this.querySelector('.matching-laces-more-toggle');
          if (matchingLacesOptions) {
            matchingLacesOptions.classList.remove('matching-laces-options--expanded');
          }
          if (matchingLacesMoreToggle) {
            matchingLacesMoreToggle.setAttribute('aria-expanded', 'false');
            matchingLacesMoreToggle.setAttribute('aria-label', 'Show more matching laces');
          }

          this.toggleAddToCartButton();
        }

        async handleClick(event) {
          // Only handle the main add-to-cart submit button
          if (!event.target.matches('.addon-submit-button')) return;

          event.preventDefault();

          if (!this.validateFields()) return;

          // Add loading spinner to body
          document.body.classList.add('loading-spinner');
          if (typeof window.showCustomLoadingOverlay === 'function') {
            window.showCustomLoadingOverlay();
          }

          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

          try {
            await this.addProductsToCart();
            this.resetForm();
          } catch (error) {
            console.error('Error adding products to cart:', error);
            alert(error.message || 'An error occurred while adding products to cart');
          } finally {
            document.body.classList.remove('loading-spinner');
            if (typeof window.hideCustomLoadingOverlay === 'function') {
              window.hideCustomLoadingOverlay();
            }
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          }
        }

        async addProductsToCart() {
          // Get product handle from current URL path - this is the most reliable source
          // as it always reflects the current PDP product, not any pair-with products
          // Handle both pathname and full href to account for mobile browsers that might use hash routing
          const currentPath = window.location.pathname || window.location.href.split('?')[0].split('#')[0];
          const productPathMatch = currentPath.match(/\/products\/([^\/\?#]+)/);
          let mainProductTitle = productPathMatch ? productPathMatch[1] : null;
          
          // Fallback to dataset if URL parsing fails (shouldn't happen on product pages)
          if (!mainProductTitle) {
            mainProductTitle = this.dataset.productHandle || this.productHandle;
            console.warn('[Add to Cart] Product handle not found in URL, using dataset:', mainProductTitle);
          }
          
          // Additional fallback: try to get from the main PDP product form if available
          // IMPORTANT: Exclude forms inside quick-buy-modal to avoid reading cross-sell product data
          if (!mainProductTitle) {
            // Find the main product form - exclude any forms inside quick-buy-modal
            const allForms = document.querySelectorAll('form[action*="/cart/add"]');
            const mainProductForm = Array.from(allForms).find(form => {
              // Exclude forms inside quick-buy-modal or any modal
              return !form.closest('quick-buy-modal') && 
                     !form.closest('[role="dialog"]') &&
                     !form.closest('.modal');
            });
            
            if (mainProductForm) {
              const formAction = mainProductForm.getAttribute('action') || '';
              const formMatch = formAction.match(/\/products\/([^\/\?#]+)/);
              if (formMatch) {
                mainProductTitle = formMatch[1];
                console.warn('[Add to Cart] Product handle found in main product form action:', mainProductTitle);
              }
            }
          }
          
          // Validate that we have a product handle
          if (!mainProductTitle) {
            console.error('No product handle found for add-on cart. URL:', window.location.href, 'Pathname:', window.location.pathname);
            throw new Error('Unable to determine main product. Please refresh the page and try again.');
          }
          
          console.log('[Add to Cart] Main product handle:', mainProductTitle, 'Source: URL');
          
          // Get quantity from main product form (exclude modals)
          const allQuantityInputs = document.querySelectorAll('input[name="quantity"]');
          const mainQuantityInput = Array.from(allQuantityInputs).find(input => {
            return !input.closest('quick-buy-modal') && 
                   !input.closest('[role="dialog"]') &&
                   !input.closest('.modal');
          });
          const mainProductQuantity = mainQuantityInput?.value || 1;

          const items = [];

          // Get variant ID from the main product form - ensure we're reading from the PDP, not any modal
          // Find the main product form (exclude forms inside quick-buy-modal)
          const allForms = document.querySelectorAll('form[action*="/cart/add"]');
          const mainProductForm = Array.from(allForms).find(form => {
            return !form.closest('quick-buy-modal') && 
                   !form.closest('[role="dialog"]') &&
                   !form.closest('.modal');
          });
          
          let mainVariantId = null;
          
          // Try to get variant ID from main product form first
          if (mainProductForm) {
            const variantInput = mainProductForm.querySelector('input[name="id"]');
            if (variantInput && variantInput.value) {
              mainVariantId = parseInt(variantInput.value, 10);
            }
          }
          
          // Fallback to stored selectedVariantId if form doesn't have it
          if (!mainVariantId || isNaN(mainVariantId)) {
            mainVariantId = typeof this.selectedVariantId === 'string' 
              ? parseInt(this.selectedVariantId, 10) 
              : this.selectedVariantId;
          }
          
          // Final fallback to dataset attribute
          if (!mainVariantId || isNaN(mainVariantId)) {
            const datasetVariantId = this.dataset.productSelectedVariant;
            if (datasetVariantId) {
              mainVariantId = parseInt(datasetVariantId, 10);
            }
          }
          
          if (!mainVariantId || isNaN(mainVariantId)) {
            console.error('[Add to Cart] Unable to determine variant ID. Form:', mainProductForm, 'Stored:', this.selectedVariantId, 'Dataset:', this.dataset.productSelectedVariant);
            throw new Error('Unable to determine product variant. Please refresh the page and try again.');
          }
          
          console.log('[Add to Cart] Main variant ID:', mainVariantId, 'Source:', mainProductForm ? 'form' : 'stored');

          const nestedQuantity = parseInt(mainProductQuantity, 10);

          const pushNestedAddon = (variantId, extraProperties = {}) => {
            const nestedItem = {
              id: variantId,
              quantity: nestedQuantity,
              parent_id: mainVariantId,
            };
            const properties = {};
            Object.entries(extraProperties).forEach(([key, value]) => {
              if (value) properties[key] = value;
            });
            if (Object.keys(properties).length > 0) {
              nestedItem.properties = properties;
            }
            items.push(nestedItem);
          };

          items.push({
            id: mainVariantId,
            quantity: nestedQuantity,
          });

          const preDrapeSection = this.querySelector('.pre-drape-section');
          if (preDrapeSection && this.querySelector('.pre-drape-checkbox').checked) {
            const preDrapeChecked = this.querySelector('input.pre-drape-size:checked');
            const preDrapeMessageInput = this.querySelector('.pre-drape-message-input');
            const preDrapeMessage = preDrapeMessageInput?.value?.trim?.() ?? '';

            const variantId = preDrapeChecked?.value ? parseInt(preDrapeChecked.value, 10) : null;

            if (!variantId || isNaN(variantId)) {
              throw new Error('Please select a size for pre-drape service');
            }

            console.log('Selected pre-drape variant ID:', variantId);
            pushNestedAddon(variantId, preDrapeMessage ? { instructions: preDrapeMessage } : {});
          }

          const blouseCustomizationSection = this.querySelector('.blouse-customization-section');
          if (blouseCustomizationSection && this.querySelector('.blouse-customization-checkbox').checked) {
            const sizeSelect = this.querySelector('.blouse-customization-size');
            const blouseCustomizationMessageInput = this.querySelector('.blouse-customization-message-input');
            const blouseCustomizationMessage = blouseCustomizationMessageInput?.value?.trim?.() ?? '';

            const variantId = sizeSelect.value ? parseInt(sizeSelect.value, 10) : null;

            if (!variantId || isNaN(variantId)) {
              throw new Error('Please select a size for blouse customization');
            }

            console.log('Selected blouse customization variant ID:', variantId);
            pushNestedAddon(variantId, blouseCustomizationMessage ? { instructions: blouseCustomizationMessage } : {});
          }

          this.querySelectorAll('.addon-option').forEach((addonOption) => {
            const addonCheckbox = addonOption.querySelector('.addon-checkbox');
            if (addonCheckbox.checked) {
              const sizeSelect = addonOption.querySelector('.addon-size');
              let selectedVariantId;

              if (sizeSelect && sizeSelect.value) {
                selectedVariantId = parseInt(sizeSelect.value, 10);
                if (isNaN(selectedVariantId)) {
                  throw new Error('Invalid variant ID for addon');
                }
              } else {
                try {
                  const variantsData = JSON.parse(addonOption.dataset.variants);
                  if (variantsData && variantsData.length > 0) {
                    selectedVariantId = parseInt(variantsData[0].id, 10);
                  } else {
                    throw new Error('No variants found');
                  }
                } catch (e) {
                  console.error('Error parsing addon variants:', e);
                  alert('Error selecting addon variant. Please try again.');
                  return;
                }
              }

              pushNestedAddon(selectedVariantId);
            }
          });

          this.querySelectorAll('.gift-wrap-option').forEach((giftWrapOption) => {
            const giftWrapCheckbox = giftWrapOption.querySelector('.gift-wrap-option-checkbox');
            if (giftWrapCheckbox.checked) {
              const giftWrapVariantId = giftWrapOption.dataset.variantId;
              items.push({
                id: giftWrapVariantId,
                quantity: 1,
                properties: {
                  _is_gift_wrap: 'Yes',
                },
              });
            }
          });

          this.querySelectorAll('.gift-box-option').forEach((giftBoxOption) => {
            const giftBoxCheckbox = giftBoxOption.querySelector('.gift-box-option-checkbox');
            if (giftBoxCheckbox.checked) {
              const giftBoxVariantId = giftBoxOption.dataset.variantId;
              items.push({
                id: giftBoxVariantId,
                quantity: 1,
              });
            }
          });

          this.querySelectorAll('.bags-option').forEach((bagsOption) => {
            const bagsCheckbox = bagsOption.querySelector('.bags-option-checkbox');
            if (bagsCheckbox.checked) {
              const bagsVariantId = bagsOption.dataset.variantId;
              items.push({
                id: bagsVariantId,
                quantity: 1,
                properties: {
                  _is_bag: 'Yes',
                },
              });
            }
          });

          this.querySelectorAll('.matching-laces-option').forEach((laceOption) => {
            const laceCheckbox = laceOption.querySelector('.matching-laces-option-checkbox');
            if (laceCheckbox?.checked) {
              const laceVariantId = laceOption.dataset.variantId;
              items.push({
                id: laceVariantId,
                quantity: 1,
              });
            }
          });

          const removeCupsSection = this.querySelector('.remove-cups-section');
          if (removeCupsSection && this.querySelector('.remove-cups-checkbox').checked) {
            const removeCupsMessageInput = this.querySelector('.remove-cups-message-input');
            const removeCupsMessage = removeCupsMessageInput?.value?.trim?.() ?? '';

            const removeCupsVariantId = removeCupsSection.dataset.variantId
              ? parseInt(removeCupsSection.dataset.variantId, 10)
              : null;

            if (!removeCupsVariantId || isNaN(removeCupsVariantId)) {
              throw new Error('Unable to determine remove cups variant');
            }

            pushNestedAddon(removeCupsVariantId, removeCupsMessage ? { instructions: removeCupsMessage } : {});
          }

          const nestedVariantIds = items
            .filter((item) => item.parent_id)
            .map((item) => String(item.id))
            .sort();

          if (nestedVariantIds.length > 0) {
            items[0].properties = {
              ...(items[0].properties || {}),
              _bundle_key: nestedVariantIds.join(','),
            };
          }

          // Prepare sections for cart update
          let sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            })
          );

          console.log('[Add to Cart] Items being added:', JSON.stringify(items, null, 2));

          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items: items,
              sections: sectionsToBundle.join(','),
              sections_url: window.location.pathname,
            }),
          });

          const responseJson = await response.json();

          if (response.ok) {
            if (window.themeVariables.settings.cartType === 'page') {
              window.location.href = `${window.Shopify.routes.root}cart`;
              return;
            }

            const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
            cartContent.sections = responseJson.sections;

            // Dispatch cart events
            this.dispatchEvent(
              new CustomEvent('variant:add', {
                bubbles: true,
                detail: {
                  items: responseJson.items || [responseJson],
                  cart: cartContent,
                },
              })
            );

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  cart: cartContent,
                },
              })
            );
          } else {
            // Handle different error formats from Shopify
            let errorMessage = responseJson.description || responseJson.message || 'Unable to add items to cart';
            
            // Check if there's a more detailed error message
            if (responseJson.errors) {
              if (typeof responseJson.errors === 'string') {
                errorMessage = responseJson.errors;
              } else if (typeof responseJson.errors === 'object') {
                errorMessage = Object.values(responseJson.errors).flat().join(', ');
              }
            }
            
            // Check for availability errors
            if (errorMessage.toLowerCase().includes('sold out') || 
                errorMessage.toLowerCase().includes('out of stock') || 
                errorMessage.toLowerCase().includes('not available')) {
              errorMessage = 'One or more items are currently out of stock. Please review your selections and try again.\n\nDetails: ' + errorMessage;
            }
            
            throw new Error(errorMessage);
          }
        }
      }

      customElements.define('product-addon-cart', ProductAddonCart);
    });
